import {SET} from './actionTypes';

const initialState = [];

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.points;

    default:
      return state;
  }
};